import { isTypedObject } from "./entity-model/typed-object.js";
export var VisualModelDataVersion;
(function (VisualModelDataVersion) {
    VisualModelDataVersion[VisualModelDataVersion["VERSION_0"] = 0] = "VERSION_0";
    /**
     * Changes from previous version:
     * - edges detected based on decimal position
     * - model assigned to UNKNOWN_MODEL
     */
    VisualModelDataVersion[VisualModelDataVersion["VERSION_1"] = 1] = "VERSION_1";
})(VisualModelDataVersion || (VisualModelDataVersion = {}));
;
export const VisualModelType = "visual-model";
export function isVisualModel(what) {
    return isTypedObject(what) && what.getTypes().includes(VisualModelType);
}
export const WritableVisualModelType = "writable-visual-model";
export function isWritableVisualModel(what) {
    return isTypedObject(what) && what.getTypes().includes(WritableVisualModelType);
}
//# sourceMappingURL=visual-model.js.map